import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { CardMessagingActivity, CardMessagingActivityProps } from 'embeds/components';

import { CardMessagingActivityQueued_EmbedQuery$key } from './__generated__/CardMessagingActivityQueued_EmbedQuery.graphql';

export interface CardMessagingActivityQueuedProps extends Omit<CardMessagingActivityProps, 'classes' | 'count'> {
  fragmentRef: CardMessagingActivityQueued_EmbedQuery$key;
}

const CardMessagingActivityQueued: React.FC<CardMessagingActivityQueuedProps> = ({ fragmentRef, ...rest }) => {
  const { queuedCount } = useFragment<CardMessagingActivityQueued_EmbedQuery$key>(
    graphql`
      fragment CardMessagingActivityQueued_EmbedQuery on Query
        @argumentDefinitions(sendAtFrom: { type: "Date!" }, sendAtTo: { type: "Date!" }) {
        queuedCount: reminderCount(
          filter: {
            _operators: { status: { in: [sent, scheduled, pending] }, sendAt: { gte: $sendAtFrom, lte: $sendAtTo } }
          }
        )
      }
    `,
    fragmentRef,
  );

  return <CardMessagingActivity count={queuedCount || 0} {...rest} />;
};

export default CardMessagingActivityQueued;
